module.exports = __webpack_public_path__ + "img/SketchPng6b2e7a7c92f9c386416047f38f398bb0ccd019ef8551b50424e68f8d8f856d7a.b78a7639.png";